import axios from 'src/api/Api';
import {
    GET_ORDERS_SUMMARY_SUCCESS,
    GET_ORDERS_SUMMARY_FAILURE,
} from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams, generate_UUID } from 'src/utils/util';
import { OrderSummaryTabs } from 'src/constants/orderListConstants';
import { setPageLoader } from 'src/pages/reportUsage/redux/action/actionCreators';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* orderSummarySaga(action) {
    const isFromOrderHistory = action?.payload?.isFromOrderHistory || false;
    const params = convertObjectToQueryParams({
        myCaseRef: action.payload.myCaseRef,
        resourceType: action.payload?.resourceType
            ? action.payload.resourceType
            : 'ALL',
    });
    let insideCatch = false;
    let responseData;
let url = '';
    if (isFromOrderHistory) {
         url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderHistorySummary?${params}`;
    }else{
     url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/summary?${params}`;
}
    try {
        const result = yield axios
            .get(url)
            .then((response) => response.data)
            .catch((error) => {
                if (error.response) {
                    // Request made and server responded
                    insideCatch = true;
                    responseData = error.response.data;
                } else if (error.request) {
                    // The request was made but no response was received
                }
            });

        if (insideCatch) {
            yield put(setPageLoader(false)); // Stop loading
            yield put({
                type: GET_ORDERS_SUMMARY_FAILURE,
                statusCode: responseData.statusCode,
                statusMessage: responseData.statusDescription,
            });
            insideCatch = false;
        } else {
            if (!result || typeof result !== 'object') {
                yield put(setPageLoader(false)); // Stop loading
                yield put({
                    type: GET_ORDERS_SUMMARY_FAILURE,
                    statusCode: '503',
                    statusMessage: errorHandler('503'),
                });
                return;
            }

            const tabListDetails = yield Object.keys(result).map((key) => {
                const sectionValue = result[key];

                return (
                    sectionValue &&
                    typeof sectionValue === 'object' &&
                    Object.keys(sectionValue).length !== 0 &&
                    key
                );
            });

            const selectedTab = {
                selectedTabId: '',
            };

            if (
                result?.orderBasicDetails?.currentOrderType === 'KE' ||
                result?.orderBasicDetails?.currentOrderType === 'ZKA'
            ) {
                selectedTab.selectedTabId = OrderSummaryTabs()[1].id;
            }

            yield put({
                type: GET_ORDERS_SUMMARY_SUCCESS,
                data: {
                    ...result,
                    orderBasicDetails: result.orderBasicDetails
                        ? {
                              ...result.orderBasicDetails,
                              isFromOrderHistory,
                          }
                        : result.orderBasicDetails,
                    reportProcedureData: result.procedureData,
                    tabLists: tabListDetails,
                    orderSummaryModal: action.payload.orderSummaryModal,
                    myCaseRef: action.payload.myCaseRef,
                    orderDetails: result.orderDetails
                        ?.filter(
                            (i) => i && typeof i === 'object' && Object.keys(i).length !== 0
                        )
                        ?.map((d)=>{
                        return {
                            ...d,
                            productKey:generate_UUID(),
                            isOrderHistoryItem: isFromOrderHistory,
                            productMoreDetails:d?.productMoreDetails?.billOfMaterials ? {
                                billOfMaterials:d?.productMoreDetails?.billOfMaterials?.map((e)=>{
                                    return {
                                        ...e,
                                        productKey:generate_UUID(),
                                        isOrderHistoryItem: isFromOrderHistory,
                                    };
                                })
                            } : {}
                        };
                    }),
                    ...selectedTab,
                },
            });
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put(setPageLoader(false)); // Stop loading
        yield put({
            type: GET_ORDERS_SUMMARY_FAILURE,
            statusCode: '503',
            statusMessage: errorHandler('503'),
        });
    }
}
